module.exports = __webpack_public_path__ + "img/item10.af3aefa1.png";